import { render, staticRenderFns } from "./SummaryFooter.vue?vue&type=template&id=634cd15a&scoped=true"
import script from "./SummaryFooter.vue?vue&type=script&lang=js"
export * from "./SummaryFooter.vue?vue&type=script&lang=js"
import style0 from "./SummaryFooter.vue?vue&type=style&index=0&id=634cd15a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634cd15a",
  null
  
)

export default component.exports